import { useEffect } from "react";
import axios from "axios";

// Cookie-less page-view ping for the public marketing pages.
// Respects the cookie banner: no ping when the visitor declined.
export default function usePageView(path) {
  useEffect(() => {
    try {
      const consent = JSON.parse(localStorage.getItem("encore_cookie_consent") || "null");
      if (consent?.choice === "declined") return;
    } catch {
      // ignore malformed consent value and track as default
    }
    axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/public/page-view`, { path }).catch(() => {});
  }, [path]);
}
